/* 
    Map of colors used for bubbles
 */
export const Colors = {
    red: {
        fill: 0xFD8384,
        alpha: 1,
        stroke: 0xFF0000,
        strokeWidth: 2
    },
    blue: {
        fill: 0x8386FC,
        alpha: 1,
        stroke: 0x0000FF,
        strokeWidth: 2
    },
    green: {
        fill: 0xCAF6CB,
        alpha: 1,
        stroke: 0x90EE90,
        strokeWidth: 2 
    },
    yellow: {
        fill: 0xFFFE00,
        alpha: 1,
        stroke: 0xd7df01,
        strokeWidth: 2 
    },
    purple: {
        fill: 0xCF95F6,
        alpha: 1,
        stroke: 0xA020F0,
        strokeWidth: 2 
    },
    skyBlue: {
        fill: 0xD8F5FE,
        alpha: 1,
        stroke: 0xaeebff,
        strokeWidth: 2 
    },
    orange: {
        fill: 0xFED287, 
        alpha: 1,
        stroke: 0xFFA500,
        strokeWidth: 2
    },
    pink: {
        fill: 0xff91c8,
        alpha: 1,
        stroke: 0xFF69B4,
        strokeWidth: 2
    },
    white: {
        fill: 0xFFFFFF,
        alpha: 1,
        stroke: 0xDDDDDD,
        strokeWidth: 2
    },
    grey: {
        fill: 0xEEEEEE,
        alpha: 1,
        stroke: 0xCCCCCC,
        strokeWidth: 2
    },
    // TODO
    rainbow: {
        fill: null,
        alpha: null,
        stroke: null,
        strokeWidth: null 
    },
    gold: {
        fill: 0xFEEA89,
        alpha: 1,
        stroke: 0xDAA520,
        strokeWidth: 2
    }
};